import { render } from "./TermsOfService.vue?vue&type=template&id=88d5eee6&scoped=true"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"

import "@/assets/css/style_parts.css?vue&type=style&index=0&id=88d5eee6&lang=css&scoped=true"
import "@/assets/css/style_ranking.css?vue&type=style&index=1&id=88d5eee6&lang=css&scoped=true"
import "@/assets/css/style_select.css?vue&type=style&index=2&id=88d5eee6&lang=css&scoped=true"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88d5eee6"]])

export default __exports__